import { render, staticRenderFns } from "./billing-modal-delivery-notes-crud-form.vue?vue&type=template&id=65ff4b04&scoped=true&"
import script from "./billing-modal-delivery-notes-crud-form.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-delivery-notes-crud-form.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-delivery-notes-crud-form.scss?vue&type=style&index=0&id=65ff4b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff4b04",
  null
  
)

export default component.exports